function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);


  if (summary.classList.contains('header__menu-item')) {
    summary.addEventListener('mouseenter', (event) => {
      closeMegaMenu();

      event.target.parentNode.setAttribute('open', true);
    });
  }

  document.querySelector('.header').addEventListener('mouseleave', (event) => {
    if (event.relatedTarget?.classList?.contains('header') || event.relatedTarget?.classList?.contains('header-wrapper')) {
      return;
    }

    checkScreenSizeAndCloseMenu();
  })
});

// Add event listener for window resize
window.addEventListener('resize', checkScreenSizeAndCloseMenu);

// Initial check when the script loads
checkScreenSizeAndCloseMenu();

function checkScreenSizeAndCloseMenu() {
  if (window.innerWidth >= 990) {
    closeMegaMenu();
  }
}

document.querySelectorAll('[js-mega-menu="tier1Link"]').forEach((element) => {
  if (!element) {
    return
  }

  element.addEventListener('mouseenter', () => {
    closeMegaMenu()
  })
});

function closeMegaMenu() {
  document.querySelectorAll('[id^="Details-"][open]').forEach((openSummary) => {
    openSummary.removeAttribute('open');
  });
}

class SectionId {
  static #separator = '__';

  // for a qualified section id (e.g. '_GiftData?.template--22224696705326__main'), return just the section id (e.g. '_GiftData?.template--22224696705326')
  static parseId(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[0];
  }

  // for a qualified section id (e.g. '_GiftData?.template--22224696705326__main'), return just the section name (e.g. 'main')
  static parseSectionName(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[1];
  }

  // for a section id (e.g. '_GiftData?.template--22224696705326') and a section name (e.g. 'recommended-products'), return a qualified section id (e.g. '_GiftData?.template--22224696705326__recommended-products')
  static getIdForSection(sectionId, sectionName) {
    return `${sectionId}${SectionId.#separator}${sectionName}`;
  }
}

class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement('div');
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll('[id], [form]').forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = 'none';

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll('script').forEach((oldScriptTag) => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' && ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', {
      bubbles: true
    });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.target.name === 'plus') {
      if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    if (this.input.dataset.min === previousValue && event.target.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: `application/${type}`
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener ?
    target.addEventListener(eventName, callback, false) :
    target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ?
      this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) :
      this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ?
          addTrapFocus() :
          summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);

    setTimeout(() => {
      this.header.classList.remove('menu-open');
    }, 200)

    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('._GiftData?.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class BulkModal extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      if (this.innerHTML.trim() === '') {
        const productUrl = this.dataset.url.split('?')[0];
        fetch(`${productUrl}?section_id=bulk-quick-order-list`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const sourceQty = html.querySelector('.quick-order-list-container').parentNode;
            this.innerHTML = sourceQty.innerHTML;
          })
          .catch((e) => {
            console.error(e);
          });
      }
    };

    new IntersectionObserver(handleIntersection.bind(this)).observe(
      document.querySelector(`#QuickBulk-${this.dataset.productId}-${this.dataset.sectionId}`)
    );
  }
}

customElements.define('bulk-modal', BulkModal);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('_GiftData?.template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');


    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next' ?
      this.slider.scrollLeft + step * this.sliderItemOffset :
      this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          }, {
            once: true
          }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
      (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('change', (event) => {
      const target = this.getInputForEventTarget(event.target);
      this.updateSelectionMetadata(event);

      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event,
          target,
          selectedOptionValues: this.selectedOptionValues,
        },
      });
    });
  }

  updateSelectionMetadata({
    target
  }) {
    const {
      value,
      tagName
    } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      Array.from(target.options)
        .find((option) => option.getAttribute('selected'))
        .removeAttribute('selected');
      target.selectedOptions[0].setAttribute('selected', 'selected');

      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = target
        .closest('.product-form__input')
        .querySelector('[data-selected-value] > .swatch');
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }

      selectedDropdownSwatchValue.style.setProperty(
        '--swatch-focal-point',
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
      );
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  getInputForEventTarget(target) {
    return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
  }

  get selectedOptionValues() {
    return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
      ({
        dataset
      }) => dataset.optionValueId
    );
  }
}

customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
  observer = undefined;

  constructor() {
    super();
  }

  connectedCallback() {
    this.loadRecommendations(this.dataset.productId);
  }

  closeModal(modal) {
    modal.classList.remove('active');
    // Show badges again in the closed modal's card

    modal
      .closest('.card-product')
      .querySelectorAll('.card__badge')
      .forEach((badge) => {
        badge.style.display = 'block';
      });

    // Hide the quick add button if applicable

    if (window.innerWidth >= 990) {
      modal
        .closest('.card-product')
        .querySelector('.quick-add__open').style.display = 'none';
    }
  }

  loadRecommendations(productId) {
    fetch(
        `${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`
      )
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');

        html.innerHTML = text;

        const recommendations = html.querySelector('product-recommendations');

        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        if (
          !this.querySelector('slideshow-component') &&
          this.classList.contains('complementary-products')
        ) {
          this.remove();
        }
        if (html.querySelector('.grid__item')) {
          this.classList.add('product-recommendations--loaded');
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}



customElements.define('product-recommendations', ProductRecommendations);

class AccountIcon extends HTMLElement {
  constructor() {
    super();

    this.icon = this.querySelector('.icon');
  }

  connectedCallback() {
    document.addEventListener('storefront:signincompleted', this.handleStorefrontSignInCompleted.bind(this));
  }

  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode());
    }
  }
}

customElements.define('account-icon', AccountIcon);

class BulkAdd extends HTMLElement {
  constructor() {
    super();
    this.queue = [];
    this.requestStarted = false;
    this.ids = [];
  }

  startQueue(id, quantity) {
    this.queue.push({
      id,
      quantity
    });
    const interval = setInterval(() => {
      if (this.queue.length > 0) {
        if (!this.requestStarted) {
          this.sendRequest(this.queue);
        }
      } else {
        clearInterval(interval);
      }
    }, 250);
  }

  sendRequest(queue) {
    this.requestStarted = true;
    const items = {};
    queue.forEach((queueItem) => {
      items[parseInt(queueItem.id)] = queueItem.quantity;
    });
    this.queue = this.queue.filter((queueElement) => !queue.includes(queueElement));
    const quickBulkElement = this.closest('quick-order-list') || this.closest('quick-add-bulk');
    quickBulkElement.updateMultipleQty(items);
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;

    if (inputValue < event.target.dataset.min) {
      this.setValidity(event, index, window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min));
    } else if (inputValue > parseInt(event.target.max)) {
      this.setValidity(event, index, window.quickOrderListStrings.max_error.replace('[max]', event.target.max));
    } else if (inputValue % parseInt(event.target.step) != 0) {
      this.setValidity(event, index, window.quickOrderListStrings.step_error.replace('[step]', event.target.step));
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.startQueue(index, inputValue);
    }
  }

  getSectionsUrl() {
    if (window.pageNumber) {
      return `${window.location.pathname}?page=${window.pageNumber}`;
    } else {
      return `${window.location.pathname}`;
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
}

if (!customElements.get('bulk-add')) {
  customElements.define('bulk-add', BulkAdd);
}

//mobile header transition
let hamburger = document.querySelector(".mobile-hamburger-icon");
let account = document.querySelector(".mobile-account-icon");
let cart = document.querySelector(".mobile-cart-icon");
hamburger?.addEventListener("click", function () {
  account.classList.toggle("active__icon");
  cart.classList.toggle("active__icon");
});



//card-product quick-add web component
class CardProductComponent extends HTMLElement {
  constructor() {
    super();
    // Initialize the quick add button and any other required elements

    this.quickShopBtn = this.querySelector(".quick-add__open");
    this.productBadges = this.querySelectorAll(".card__badge");
    this.modalContainer = this.querySelector(".card-product__quickadd-modal");
    this.activeModal = null;
    this.addToBagBtn = this.querySelector(".add-to-cart__cta");
    this.variantForm = this.querySelector(".variant-form");
  }

  connectedCallback() {
    // Set up hover interactions on the card element
    this.addEventListener("mouseenter", this.handleMouseEnter);
    this.addEventListener("mouseleave", this.handleMouseLeave);
    this.quickShopBtn?.addEventListener(
      "click",
      this.handleQuickShopClick.bind(this)
    );

    this.changePrice();
    this.initAddToCart();
    document.addEventListener("click", this.handleDocumentClick.bind(this));
  }

  handleDocumentClick(event) {
    if (!this.contains(event.target) && this.activeModal) {
      this.modalContainer.classList.remove("active");
      this.productBadges.forEach((badge) => (badge.style.display = "block"));
      this.quickShopBtn.style.display = "none";
      this.activeModal = null;
    }
  }

  handleMouseEnter() {
    if (window.innerWidth >= 750) {
      if (this.quickShopBtn) {
        this.quickShopBtn.style.display = "flex";

        this.productBadges.forEach((badge) => (badge.style.display = "none"));
      }
    }
  }

  handleMouseLeave() {
    if (window.innerWidth >= 750) {
      if (this.modalContainer.classList.contains("active")) {
        this.modalContainer.classList.remove("active");
      }
      if (this.quickShopBtn) this.quickShopBtn.style.display = "none";
      this.productBadges.forEach((badge) => (badge.style.display = "block"));
    }
  }

  handleQuickShopClick(e) {
    e.stopPropagation();
    e.preventDefault();

    // Remove 'active' class from all modals except the current one
    document
      .querySelectorAll(".card-product__quickadd-modal.active")
      .forEach((modal) => {
        if (modal !== this.modalContainer) {
          modal.classList.remove("active");
        }
      });

    // Toggle 'active' class for the clicked button's modal
    const isCurrentlyActive = this.modalContainer.classList.contains("active");
    this.modalContainer.classList.toggle("active", !isCurrentlyActive);
    // Add a global click listener to handle clicks outside

    const handleOutsideClick = (event) => {
      const isClickInsideModal = this.modalContainer.contains(event.target);
      const isClickOnButton = e.target.contains(event.target);
      if (!isClickInsideModal && !isClickOnButton) {
        // Remove 'active' class if clicked outside
        this.modalContainer.classList.remove("active");
        // Remove the event listener once it's no longer needed
        document.removeEventListener("click", handleOutsideClick);
      }
    };

    // Add the event listener if the modal becomes active

    if (!isCurrentlyActive) {
      document.addEventListener("click", handleOutsideClick);
    }
  }

  changePrice() {
    const addToBagButton = this.addToBagBtn;
    this.querySelectorAll('.radio-options input[type="radio"]')?.forEach(
      function (radio) {
        radio.addEventListener("change", function (event) {
          const add_to_cart_text = addToBagButton.getAttribute("add-to-cart");

          addToBagButton.innerHTML = `
                              <span class="loading display-none">
                      <div class="loading-spinner">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                          focusable="false"
                          aria-label="Processing…"
                          class="loading-spinner-svg"
                        >
                          <path d="M20 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0v2a8 8 0 1 0 8 8z"></path>
                        </svg>
                      </div>
                    </span>
     <p class="add-to-cart__cta-text">
     ${add_to_cart_text} | ${this.dataset.price}
      </p>
      `;
        });
      }
    );
  }

  initAddToCart() {
    const addToCartButton = this.addToBagBtn;
    const form = this.variantForm;
    this.variantForm?.addEventListener("submit", async (event) => {
      event.preventDefault();
      this.toogleLoading();
      const ctaVariantValue = addToCartButton.getAttribute("value");
      const dataPreorderShippingDate = addToCartButton.getAttribute(
        "data-preorder-shippingdate"
      );
      const variantId = ctaVariantValue ?
        ctaVariantValue :
        form.querySelector('input[name="variant"]:checked').value;

      await this.quickAddToCart(variantId, dataPreorderShippingDate);
    });
  }

  toogleLoading() {
    this.addToBagBtn.disabled = !this.addToBagBtn.disabled;
    if (this.addToBagBtn.disabled) {
      this.addToBagBtn.classList.remove("btn", "primary");
    } else {
      this.addToBagBtn.classList.add("btn", "primary");
    }
    this.addToBagBtn.querySelector(".loading").classList.toggle("display-none");
    this.addToBagBtn
      .querySelector(".add-to-cart__cta-text")
      .classList.toggle("display-none");
  }

  async quickAddToCart(variantId, dataPreorderShippingDate) {
    const data = {
      id: variantId,
      quantity: 1,
      properties: {},
    };
    if (dataPreorderShippingDate) {
      data.properties["_shipping_date"] = dataPreorderShippingDate;
    }

    try {
      const addToCartResponse = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
      await this.rerenderCartDrawer([
        ".drawer__inner",
        "#cart-icon-bubble",
        "#desktop-cart-icon-bubble",
      ]);
    } catch (error) {
      console.error(error);
    }
  }

  async rerenderCartDrawer(selectors) {
    try {
      const cartResponse = await fetch("/cart", {
        method: "GET",
        headers: {
          "Content-Type": "text/html",
          Accept: "text/html",
        },
      });

      if (!cartResponse.ok) {
        throw new Error("Error fetching cart");
      }

      const html = await cartResponse.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");

      const drawer = document.querySelector("cart-drawer");
      document.body.classList.add("overflow-hidden");
      drawer.classList.add("active");
      if (drawer.classList.contains("is-empty")) {
        drawer.classList.remove("is-empty");
      }

      selectors.forEach((selector) => {
        const newElement = doc.querySelector(selector);
        const currentElement = document.querySelector(selector);

        if (currentElement && newElement) {
          currentElement.innerHTML = newElement.innerHTML;
        }
      });
      document.dispatchEvent(new Event("freegift:updated"));
      this.toogleLoading();
    } catch (error) {
      console.error("Error re-rendering cart drawer:", error);
    }
  }

  disconnectedCallback() {
    // Clean up event listeners
    this.removeEventListener("mouseenter", this.handleMouseEnter);
    this.removeEventListener("mouseleave", this.handleMouseLeave);
    this.quickShopBtn?.removeEventListener("click", this.handleQuickShopClick);
    document.removeEventListener("click", this.handleDocumentClick);
  }
}

customElements.define('card-product-component', CardProductComponent);
//Cusotm pagination
class CustomPagination extends HTMLElement {
  constructor() {
    super();
    this.itemsPerPage = parseInt(this.getAttribute("items-per-page")) || 5;
    this.originalContent = null;
  }

  connectedCallback() {
    this.originalContent = Array.from(
      this.querySelector("#paginate-body").children
    );
    this.render();

    window.addEventListener("resize", () => this.render());
  }

  get currentPage() {
    const urlParams = new URLSearchParams(window.location.search);
    return parseInt(urlParams.get("page")) || 1;
  }

  set currentPage(page) {
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.set("page", page);
    window.location.search = urlParams.toString();
  }

  render() {
    if (!this.originalContent) return;

    const totalItems = this.originalContent.length;
    const totalPages = Math.ceil(totalItems / this.itemsPerPage);

    const startIdx = (this.currentPage - 1) * this.itemsPerPage;
    const endIdx = startIdx + this.itemsPerPage;

    const orderBody = this.querySelector("#paginate-body");
    orderBody.innerHTML = "";

    this.originalContent.slice(startIdx, endIdx).forEach((item) => {
      orderBody.appendChild(item.cloneNode(true));
    });

    this.renderPaginationControls(totalPages);
  }

  renderPaginationControls(totalPages) {
    const existingControls = this.querySelector(".pagination-controls");
    if (existingControls) {
      existingControls.remove();
    }

    const controls = document.createElement("div");
    controls.classList.add("pagination-controls", "body-2");

    if (this.currentPage > 1) {
      controls.appendChild(
        this.createPageSpan(
          "Previous",
          this.currentPage - 1,
          false,
          "pagination-prev"
        )
      );
    } else {
      const prevSpan = this.createPageSpan(
        "Previous",
        1,
        false,
        "pagination-prev"
      );
      prevSpan.style.visibility = "hidden";
      controls.appendChild(prevSpan);
    }
    // Updated logic for handling desktop and mobile pagination ranges
    const pageNumbers = this.getPageNumbers(totalPages);
    pageNumbers.forEach((page) => {
      if (page === "...") {
        controls.appendChild(this.createEllipsisSpan());
      } else {
        controls.appendChild(
          this.createPageSpan(
            page,
            page,
            page === this.currentPage,
            "page-number"
          )
        );
      }
    });

    if (this.currentPage < totalPages) {
      controls.appendChild(
        this.createPageSpan(
          "Next",
          this.currentPage + 1,
          false,
          "pagination-next"
        )
      );
    } else {
      const nextSpan = this.createPageSpan(
        "Next",
        totalPages,
        false,
        "pagination-next"
      );
      nextSpan.style.visibility = "hidden";
      controls.appendChild(nextSpan);
    }

    this.appendChild(controls);
  }

  getPageNumbers(totalPages) {
    const range = [];
    const isMobile = window.innerWidth <= 768; // Mobile breakpoint

    if (isMobile) {
      // Mobile-specific pagination logic
      range.push(1); // Always include the first page

      if (totalPages <= 3) {
        // If total pages are 3 or less, include all pages
        for (let i = 2; i <= totalPages; i++) {
          range.push(i);
        }
      } else {
        // If current page is 1 or 2, show 1, 2, and ellipsis
        if (this.currentPage === 1 || this.currentPage === 2) {
          range.push(2);
          range.push("...");
        }
        // If current page is the last page or the second to last page, show ellipsis and last two pages
        else if (this.currentPage === totalPages || this.currentPage == totalPages - 1) {
          range.push("...");
          range.push(totalPages - 1);
        }
        // Otherwise, show ellipsis, current page, and another ellipsis
        else {
          range.push("...");
          range.push(this.currentPage);
          range.push("...");
        }

        range.push(totalPages); // Always include the last page
      }
    } else {
      // Desktop-specific pagination logic
      const maxVisible = 5;
      range.push(1);

      if (totalPages <= maxVisible) {
        for (let i = 2; i <= totalPages; i++) {
          range.push(i);
        }
      } else {
        const isNearStart = this.currentPage <= 3;
        const isNearEnd = this.currentPage >= totalPages - 2;

        if (isNearStart) {
          for (let i = 2; i <= 4; i++) {
            range.push(i);
          }
          range.push("...");
          range.push(totalPages);
        } else if (isNearEnd) {
          range.push("...");
          for (let i = totalPages - 3; i < totalPages; i++) {
            range.push(i);
          }
          range.push(totalPages);
        } else {
          range.push("...");
          range.push(this.currentPage - 1);
          range.push(this.currentPage);
          range.push(this.currentPage + 1);
          range.push("...");
          range.push(totalPages);
        }
      }
    }

    return range;
  }

  createPageSpan(label, page, isCurrent, className, text = label) {
    const span = document.createElement("span");
    if (label === "Previous") {
      const textSpan = document.createElement("span");
      textSpan.classList.add("page-prev");
      textSpan.textContent = ` ${text}`;
      span.innerHTML = `<svg class="icon icon-caret" viewBox="0 0 10 6"><path fill="currentColor" fill-rule="evenodd" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708" clip-rule="evenodd"/></svg>`;
      span.appendChild(textSpan);
    } else if (label === "Next") {
      const textSpan = document.createElement("span");
      textSpan.classList.add("page-nxt");
      textSpan.textContent = ` ${text}`;
      span.appendChild(textSpan);
      span.innerHTML += `<svg class="icon icon-caret" viewBox="0 0 10 6"><path fill="currentColor" fill-rule="evenodd" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708" clip-rule="evenodd"/></svg>`;
    } else {
      span.textContent = text;
    }
    span.classList.add(className);

    if (isCurrent) {
      span.classList.add("current-page");
    }

    //popo(use a different css file)

    span.addEventListener("click", (e) => {
      e.preventDefault();
      this.currentPage = page;
    });

    return span;
  }

  createEllipsisSpan() {
    const span = document.createElement("span");
    span.textContent = "...";
    span.classList.add("ellipsis");
    return span;
  }
}

customElements.define("custom-pagination", CustomPagination);
class ImageVideoContainer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const video = this.querySelector('video');
    this.addVideoPlayPauseToggle(video);
    this.addSoundMuteUnmuteToggle(video);
  }

  addVideoPlayPauseToggle(video) {
    const playPauseBtn = this.querySelector('.video-play-pause-control');
    const playIcon = playPauseBtn?.querySelector('.play-button');
    const pauseIcon = playPauseBtn?.querySelector('.pause-button');

    if (video && playPauseBtn) {
      // Initial setup based on the video playing state
      video.addEventListener('play', () => {
        playIcon.classList.add('display-none'); // Hide play icon
        pauseIcon.classList.remove('display-none'); // Show pause icon
      });

      video.addEventListener('pause', () => {
        playIcon.classList.remove('display-none'); // Show play icon
        pauseIcon.classList.add('display-none'); // Hide pause icon
      });

      // Set initial state based on whether the video is autoplaying or paused
      if (video.paused) {
        playIcon?.classList.remove('display-none'); // Show play icon
        pauseIcon?.classList.add('display-none'); // Hide pause icon
      } else {
        playIcon?.classList.add('display-none'); // Hide play icon
        pauseIcon?.classList.remove('display-none'); // Show pause icon
      }

      // Add event listener to toggle play/pause on button click
      playPauseBtn.addEventListener('click', () => {
        if (video.paused) {
          video.play();
        } else {
          video.pause();
        }
      });
    }
  }

  addSoundMuteUnmuteToggle(video) {
    const muteUnmuteBtn = this.querySelector('.video-sound-control');
    const muteIcon = muteUnmuteBtn?.querySelector('.mute-button');
    const soundIcon = muteUnmuteBtn?.querySelector('.sound-button');

    if (video && muteUnmuteBtn) {
      // Add event listener to toggle mute/unmute on button click
      muteUnmuteBtn.addEventListener('click', () => {
        if (video.muted) {
          video.muted = false;
          muteIcon?.classList.add('display-none'); // Show mute icon
          soundIcon?.classList.remove('display-none'); // Hide unmute icon
        } else {
          video.muted = true;
          muteIcon?.classList.remove('display-none'); // Hide mute icon
          soundIcon?.classList.add('display-none'); // Show unmute icon
        }
      });
    }

  }

}

customElements.define('image-video-container', ImageVideoContainer);

class GiftWrap extends HTMLElement {
  constructor() {
    super();

    this.giftNoteInput = this.querySelector('#gift-wrap__note__input_text');
    this.addGiftCardButton = this.querySelector('#add-gift-message-btn');
    this.giftWrapCheckboxes = this.querySelectorAll('.gift-wrapper-checkbox');
  }

  connectedCallback() {
    this.addGiftCardButton?.addEventListener(
      'click',
      this.addGiftCardMessage.bind(this)
    );

    this.giftWrapCheckboxes?.forEach((checkbox) => {
      checkbox.addEventListener('change', async (event) => {
        // Disable all checkboxes
        this.giftWrapCheckboxes.forEach((cb) => cb.setAttribute('disabled', 'disabled'));

        if (checkbox.checked) {
          // Uncheck all other checkboxes
          this.giftWrapCheckboxes.forEach((otherCheckbox) => {
            if (otherCheckbox !== checkbox) {
              otherCheckbox.checked = false;
            }
          });

          try {
            await this.removePreviousGiftWraps();
            await this.addGiftWrap(checkbox.value);
          } catch (error) {
            console.error('Error adding gift wrap:', error);
          }
        } else {
          try {
            await this.removeGiftWrap(checkbox.value);
          } catch (error) {
            console.error('Error removing gift wrap:', error);
          }
        }

        // Re-enable all checkboxes
        this.giftWrapCheckboxes.forEach((cb) => cb.removeAttribute('disabled'));
      });
    });

    this.giftNoteInput?.addEventListener('input', (event) => {
      const btnPrevText = this.addGiftCardButton.textContent;
      if (event.target.value === '') {
        this.addGiftCardMessage();
        this.addGiftCardButton.innerHTML = 'Add gift message';
      } else {
        this.addGiftCardButton.innerHTML = btnPrevText;
      }
    });
  }

  async removeGiftWrap(productId) {
    const body = JSON.stringify({
      quantity: 0,
      id: productId
    });

    try {
      const response = await fetch(`${routes.cart_change_url}`, {
        ...fetchConfig(),
        ...{
          body
        },
      });
      const data = await response.json();
      await this.rerenderSections();
    } catch (error) {
      console.error('Error removing gift wrap from cart:', error);
    }
  }

  async addGiftWrap(productId) {
    const body = JSON.stringify({
      quantity: 1,
      id: productId,
      properties: {
        _gift_wrapper: 'Gift Wrapper'
      },
    });

    try {
      const response = await fetch(`${routes.cart_add_url}`, {
        ...fetchConfig(),
        ...{
          body
        },
      });
      const data = await response.json();
      await this.rerenderSections();
    } catch (error) {
      console.error('Error adding gift wrap to cart:', error);
    }
  }

  async removePreviousGiftWraps() {
    const removalPromises = [];

    this.giftWrapCheckboxes.forEach((checkbox) => {
      if (!checkbox.checked && checkbox.value) {
        const productId = checkbox.value;
        const body = JSON.stringify({
          quantity: 0,
          id: productId
        });
        const removalPromise = fetch(`${routes.cart_change_url}`, {
            ...fetchConfig(),
            ...{
              body
            },
          })
          .then((res) => res.json())
          .catch((error) => {
            console.error('Error removing gift wrap from cart:', error);
          });
        removalPromises.push(removalPromise);
      }
    });

    await Promise.all(removalPromises);
  }

  async addGiftCardMessage() {
    const body = JSON.stringify({
      note: this.giftNoteInput.value
    });

    try {
      const response = await fetch(`${routes.cart_update_url}`, {
        ...fetchConfig(),
        ...{
          body
        },
      });
      const data = await response.json();
      this.updateButton(data.note);
    } catch (error) {
      console.error('Error updating gift message:', error);
    }
  }

  updateButton(cartNoteResponse) {
    this.addGiftCardButton.disabled = true;
    this.addGiftCardButton.textContent = _CartNote ?
      'Updated gift message' :
      'Added gift message';
    setTimeout(() => {
      this.addGiftCardButton.disabled = false;
      this.addGiftCardButton.textContent = cartNoteResponse ?
        'Update gift message' :
        'Add gift message';
    }, 2000);
  }

  async rerenderSections() {
    try {
      const response = await fetch('/cart', {
        method: 'GET',
        headers: {
          'Content-Type': 'text/html',
          Accept: 'text/html',
        },
      });
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      this.updateCartSections(doc);
    } catch (error) {
      console.error('Error updating cart sections:', error);
    }
  }

  updateCartSections(doc) {
    const selectors = [
      '.drawer__inner',
      '#cart-icon-bubble',
      '#desktop-cart-icon-bubble',
      '.cart-item-wrapper',
      '.cart-page-footer-wrapper',
    ];

    // Save the open state of details elements
    const detailsElements = document.querySelectorAll('.gift-wrap details');
    const detailsState = {};
    detailsElements.forEach((details, index) => {
      detailsState[index] = details.open;
    });

    selectors.forEach((selector) => {
      const currentElement = document.querySelector(selector);
      const newElement = doc.querySelector(selector);
      if (currentElement && newElement) {
        currentElement.innerHTML = newElement.innerHTML;
      }
    });

    const newDetailsElements = document.querySelectorAll('.gift-wrap details');
    newDetailsElements.forEach((details, index) => {
      if (detailsState[index] !== undefined) {
        details.open = detailsState[index];
      }
    });
  }
}

customElements.define('gift-wrap', GiftWrap);

//web component for free samples
class FreeGifts extends HTMLElement {
  constructor() {
    super();
    this.initializeFreeGifts = this.initializeFreeGifts.bind(this);
    this.locale = window?.Shopify?.routes?.root;
    this.host = window?.Shopify?.shop;
  }

  connectedCallback() {
    this.initializeFreeGifts();
    document.addEventListener("cart:updated", this.initializeFreeGifts);
  }

  disconnectedCallback() {
    document.removeEventListener("cart:updated", this.initializeFreeGifts);
  }

  initializeFreeGifts() {
    const gift_main_container_main = this.querySelector(
      ".free-gifts_container"
    );
    const gift_main_container = this.querySelector(".free-gifts");

    fetch(`${this.locale}cart.js`)
      .then((response) => response.json())
      .then((cart) => {
        const cartTotalPrice = cart.total_price / 100;

        // Check if a gift product with the property "_gift": "cart threshold" is already in the cart
        let giftProductPresent = cart.items.find(
          (item) =>
          item.properties &&
          item.properties._gift === `${_GiftData?.giftTriggeringCriteria}`
        );
        //checking that if the gift triggering product is present in the cart or not with the required product quantity
        let triggeringProductPresent =
          _GiftData?.giftTriggeringCriteria == "products" ?
          _GiftData?.giftTriggeringProducts &&
          _GiftData?.giftTriggeringProducts.filter((product) =>
            cart.items.find(
              (item) =>
              item.product_id === product.id &&
              item.quantity >= _GiftData?.triggeringProductCount
            )
          ).length :
          _GiftData?.giftTriggeringCollectionProducts &&
          (_GiftData?.giftTriggeringCollectionProducts?.filter((product) =>
            cart.items.find(
              (item) =>
              item.product_id === product.id &&
              item.quantity >= _GiftData?.gifttriggeringCollectionProductCount
            )
          )).length;

        let giftpresentTocart = cart.items.find(
          (item) =>
          item.properties &&
          item.properties._gift === `${_GiftData?.giftTriggeringCriteria}`
        );
        if (
          _GiftData?.giftTriggeringCriteria !== "cart threshold" &&
          triggeringProductPresent >= 1
        ) {
          // Show the free gifts
          if (gift_main_container) {
            gift_main_container.classList.add("active");
            this.querySelector(
              ".free-gifts_container .free-gifts__header"
            ).classList.add("active");
          }

          //adding the first product of the gift slider to the cart automatically
          if (
            _GiftData?.giftTriggeringCriteria === "products" &&
            triggeringProductPresent >= 1 &&
            !giftpresentTocart
          ) {
            // this.addGiftProductToCart(_GiftData?.productTriggeringGifts, cart);
          } else if (
            _GiftData?.giftTriggeringCriteria === "collection" &&
            triggeringProductPresent >= 1 &&
            !giftpresentTocart
          ) {
            // this.addGiftProductToCart(_GiftData?.collectionTriggeringGifts, cart);
          }
        } else if (
          _GiftData?.giftTriggeringCriteria === "cart threshold" &&
          cartTotalPrice >= _GiftData?.thresholdValue
        ) {
          // show the free gifts
          if (gift_main_container) {
            gift_main_container.classList.add("active");
            this.querySelector(
              ".free-gifts_container .free-gifts__header"
            ).classList.add("active");
          }
        } else {
          // Hide the free gifts
          if (gift_main_container) {
            gift_main_container.classList.remove("active");
            this.querySelector(
              ".free-gifts_container .free-gifts__header"
            ).classList.remove("active");
          }
          // Remove the gift product from the cart if the cart total price is less than the threshold value
          if (
            _GiftData?.giftTriggeringCriteria === "cart threshold" &&
            cartTotalPrice < _GiftData?.thresholdValue &&
            giftProductPresent
          ) {

            this.remove_gift_product(cart);
          }
          // Remove the gift product from cart if the triggering collection product is removed from the cart
          if (
            _GiftData?.giftTriggeringCriteria === "collection" &&
            !triggeringProductPresent &&
            giftProductPresent
          ) {
            this.remove_gift_product(cart);
          }
          // Remove the gift product from the cart if the triggering product is removed from the cart
          if (
            _GiftData?.giftTriggeringCriteria === "products" &&
            !triggeringProductPresent &&
            giftProductPresent
          ) {
            this.remove_gift_product(cart);
          }
        }
        this.handleMultiplevariants(cart);

        // initialize dots states
        this.createDots(gift_main_container_main);
        this.updateDots(gift_main_container_main);

        ////////---------------- starts click and scroll event listeners for slider dots
        // Add scroll event listener to update dots
        gift_main_container_main
          .querySelector(".gift-slider__container")
          .addEventListener("scroll", () => {
            this.updateDots(gift_main_container_main);
          });

        //add click event listeners onclick of dots
        gift_main_container_main
          .querySelectorAll(".gift-dot")
          .forEach((dot, index) => {
            dot.addEventListener("click", () => {
              const products =
                gift_main_container_main.querySelectorAll(".gift-product");
              const productWidth = products[0]?.offsetWidth;
              gift_main_container_main
                .querySelector(".gift-slider__container")
                .scrollTo({
                  left: index * productWidth,
                  behavior: "smooth",
                });
            });
          });

        //add resize event listeners on dots updation
        window.addEventListener("resize", () => {
          this.updateDots(gift_main_container_main);
        });
        /////////----------------- ends click and scroll event listeners for slider dots

        // Add event listener for checkbox changes (adding and removing products from the cart)
        this.handleGiftCheckboxChange(
          ".gift-checkbox",
          _GiftData?.giftTriggeringCriteria,
          this.rerendaerSections.bind(this)
        );
      })
      .catch((error) => {
        console.error(
          "Error fetching cart or parsing triggering products:",
          error
        );
      });
  }

  addGiftProductToCart(gifts, cart) {
    if (gifts.length >= 1) {
      gifts.forEach((gift, idx) => {
        let giftProductPresent = cart.items.find(
          (item) =>
          item.properties &&
          item.properties._gift === `${_GiftData?.giftTriggeringCriteria}`
        );
        if (idx === 0) {
          if (!giftProductPresent) {
            fetch(`${this.locale}cart/add.js`, {
                method: "POST",
                headers: {
                  "Content-Type": "application/json"
                },
                body: JSON.stringify({
                  quantity: 1,
                  id: gift.variants[0].id,
                  properties: {
                    _gift: `${_GiftData?.giftTriggeringCriteria}`,
                  },
                }),
              })
              .then((response) => response.json())
              .then((data) => {
                if (_GiftData?.template == "cart") {
                  window.location.reload();
                } else {
                  this.rerendaerSections();
                } // Call rerender function
              })
              .catch((error) => {});
          }
        }
      });
    }
  }
  remove_gift_product(cart) {

    console.log('remove request: ', cart);

    let giftLine = 1;
    //finding the line value of the gift product
    for (let i = 0; i < cart.items.length; i++) {
      if (
        cart.items[i].properties &&
        cart.items[i].properties._gift === `${_GiftData?.giftTriggeringCriteria}`
      ) {
        giftLine = i + 1;
      }
    }
    const payload = {
      line: giftLine,
      quantity: 0,
    };

    fetch(`${this.locale}cart/change.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(payload),
      })
      .then((data) => {
        if (_GiftData?.template === "cart") {
          window.location.reload();
        } else this.rerendaerSections();
      })
      .catch((error) => {
        console.error("There was a problem with the fetch operation:", error);
      });
  }

  // starts for slider dots
  createDots(container) {
    const products = container.querySelectorAll(".gift-product");
    const dotsContainer = container.querySelector(".gift-slider__dots");

    if (dotsContainer) {
      dotsContainer.innerHTML = "";
    }

    let numberOfDots = products.length;
    for (let i = 0; i < numberOfDots; i++) {
      let dot = document.createElement("div");
      dot.classList.add("gift-dot");
      dot.innerHTML = " ";
      if (dotsContainer) {
        dotsContainer.appendChild(dot);
      }
    }

    if (dotsContainer.firstChild) {
      dotsContainer.firstChild.classList.add("active");
    }
  }

  // Update the active dot based on the scroll position
  updateDots(container) {
    const products = container.querySelectorAll(".gift-product");
    const dots = container.querySelectorAll(".gift-slider__dots .gift-dot");
    const scrollLeft = container.querySelector(
      ".gift-slider__container"
    ).scrollLeft;
    const productWidth = products[0]?.offsetWidth;
    const activeIndex = Math.round(scrollLeft / productWidth);

    dots.forEach((dot) => dot.classList.remove("active"));
    if (dots[activeIndex]) {
      dots[activeIndex].classList.add("active");
    }
  }

  async rerendaerSections() {
    await fetch(`${this.locale}cart`, {
        method: "GET",
        headers: {
          "Content-Type": "text/html",
          Accept: "text/html",
        },
      })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Error fetching cart");
        }
        return response.text();
      })
      .then(async (html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const newgiftsContainer = doc.querySelector(".free-gifts");
        const giftsContainer = document.querySelector(".free-gifts");
        const selectors = [
          ".drawer__inner",
          "#cart-icon-bubble",
          "#desktop-cart-icon-bubble",
          ".cart-item-wrapper",
          ".free-gifts",
        ];
        selectors.forEach((selector) => {
          const currentElement = document.querySelector(selector);
          const newElement = doc.querySelector(selector);

          if (currentElement && newElement) {
            currentElement.innerHTML = newElement.innerHTML;
          }
        });
        if (giftsContainer && newgiftsContainer) {
          giftsContainer.innerHTML = newgiftsContainer.innerHTML;
          giftsContainer.classList.add("active");
        }
        await this.handleMultiplevariants(cart);
        document.dispatchEvent(new Event("freegift:updated"));
      })
      .catch((error) => {
        console.error("Error updating cart sections:", error);
      });
  }

  handleGiftProductToCart(checkbox, gift_criteria, rerenderCallback) {
    let productId = checkbox.getAttribute("data-product-id");
    let isProcessing = false;

    fetch(`${this.locale}cart.js`)
      .then((res) => res.json())
      .then((cart) => {
        if (!cart || !cart.items) return;

        const currentGifts = cart.items
          .map((item, index) => ({
            ...item,
            line: index + 1
          }))
          .filter((item) => item.properties && item.properties._gift === gift_criteria);

        if (checkbox.checked) {
          if (isProcessing) return;
          isProcessing = true;
          checkbox.disabled = true;

          let removalPromise = Promise.resolve();

          // only allow for a max of what the admin sets
          if (currentGifts.length >= window?._GiftData?.allowedQuantity) {
            const oldestGift = currentGifts[0];
            if (oldestGift && oldestGift.line) {
              removalPromise = fetch(`${this.locale}cart/change.js`, {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json"
                  },
                  body: JSON.stringify({
                    line: oldestGift.line,
                    quantity: 0,
                  }),
                })
                .then((r) => r.json())
                .catch((err) =>
                  console.error("Error removing oldest gift before adding new one:", err)
                );
            }
          }

          removalPromise
            .then(() =>
              fetch(`${this.locale}cart/add.js`, {
                method: "POST",
                headers: {
                  "Content-Type": "application/json"
                },
                body: JSON.stringify({
                  quantity: 1,
                  id: productId,
                  properties: {
                    _gift: `${gift_criteria}`,
                  },
                }),
              })
            )
            .then((response) => response.json())
            .then(async () => {
              await rerenderCallback();
              document.dispatchEvent(new Event("freegift:updated"));
            })
            .finally(() => {
              isProcessing = false;
              checkbox.disabled = false;
            });
        } else {
          // remove gift when unchecked
          const matchedGift = cart.items.find(
            (item) => item.id == productId && item.properties?._gift === gift_criteria
          );

          if (matchedGift) {
            const line = cart.items.findIndex((i) => i.key === matchedGift.key) + 1;
            if (line > 0) {
              fetch(`${this.locale}cart/change.js`, {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json"
                  },
                  body: JSON.stringify({
                    line,
                    quantity: 0
                  }),
                })
                .then((response) => response.json())
                .then(() => rerenderCallback());
            }
          }
        }
      })
      .catch((err) => console.error("Error checking cart gifts:", err));
  }



  async handleMultiplevariants(cart) {
    let sellectedBool = [];
    const checkboxes = this.querySelectorAll(".gift-checkbox");
    checkboxes.forEach(async (checkbox) => {
      // Handle variant selection
      let selectedOptions = [];
      selectedOptions.push(checkbox.value);
      let productVariantData;
      try {
        productVariantData = await JSON.parse(checkbox.getAttribute('data-product'));
      } catch (error) {
        console.error('Error parsing product data:', error);
      }

      let matchedVariant =
        productVariantData &&
        productVariantData?.find((variant) => {
          return selectedOptions.every(
            (option, index) => option === variant.options[index]
          );
        });
      let productHasMultipleVariants = checkbox.getAttribute(
        "data-has-multiple-variants"
      );

      if (matchedVariant && productHasMultipleVariants > 1) {
        matchedVariant = {
          ...matchedVariant,
          final_price: 0
        }; // Add new key-value pair
        checkbox.setAttribute("data-product-id", Number(matchedVariant.id));
        const isVariantInCart = cart.items.some(
          (item) =>
          item.variant_id === matchedVariant.id && item.final_line_price === 0
        );
        sellectedBool.push(isVariantInCart);
        checkbox.checked = isVariantInCart;
      } else {
        // checkbox.checked = false;
      }
    });
  }
  async handleGiftCheckboxChange(checkboxSelector, gift_criteria, rerenderCallback) {
    let matchedVariant = null;
    this.querySelectorAll(checkboxSelector).forEach((checkbox) => {
      checkbox.addEventListener("change", async () => {
        let productHasMultipleVariants = checkbox.getAttribute(
          'data-has-multiple-variants'
        );

        if (productHasMultipleVariants > 1 && checkbox.checked) {
          // Handle variant selection
          let selectedOptions = [];
          selectedOptions.push(checkbox.value);
          const productVariantData = await JSON.parse(checkbox.getAttribute('data-product'));
          matchedVariant =
            productVariantData &&
            productVariantData?.variants?.find((variant) => {
              return selectedOptions.every(
                (option, index) => option === variant.options[index]
              );
            });

          if (matchedVariant) {
            await checkbox.setAttribute("data-product-id", Number(matchedVariant.id));
          }
          await this.handleGiftProductToCart(
            checkbox,
            gift_criteria,
            rerenderCallback
          );
        } else {
          await this.handleGiftProductToCart(
            checkbox,
            gift_criteria,
            rerenderCallback
          );
        }
      });
    });
  }
}

customElements.define('free-gifts', FreeGifts);


//web component for free samples
class FreeSamples extends HTMLElement {
  constructor() {
    super();
    this.initializeFreeSamples = this.initializeFreeSamples.bind(this);
    this.locale = window?.Shopify?.routes?.root;
    this.host = window?.Shopify?.shop;
  }

  connectedCallback() {
    this.initializeFreeSamples();
    checkSampleProductPresent();
    document.addEventListener('cart:updated', this.initializeFreeSamples);
  }

  disconnectedCallback() {
    document.removeEventListener('cart:updated', this.initializeFreeSamples);
    document.removeEventListener('cart:updated', checkSampleProductPresent);
    document.removeEventListener('cart:sample_updated', checkSampleProductPresent);
  }

  initializeFreeSamples() {
    const sample_main_container_main = this.querySelector('.free-samples_container');
    const sample_main_container = this.querySelector('.free-samples');
    sample_main_container.classList.add("active");
    sample_main_container_main.classList.add("active");
    this.querySelector(".free-samples_container .free-samples__header").classList.add("active");
    fetch(`${this.locale}cart.js`)
      .then(response => response.json())
      .then(cart => {
        cart.items.forEach(item => {
          if (item.properties && item.properties._sample === "free sample") {
            const checkbox = this.querySelector(`.sample-checkbox[data-product-id="${item.id}"]`);
            if (checkbox) {
              checkbox.checked = true;
            }
          }
        });


        // initialize dots states
        this.createDots(sample_main_container_main);
        this.updateDots(sample_main_container_main);

        ///////// starts click and scroll event listeners for slider dots
        // Add scroll event listener to update dots
        sample_main_container_main.querySelector('.sample-slider__container').addEventListener('scroll', () => {
          this.updateDots(sample_main_container_main);
        });

        //add click event listeners onclick of dots
        sample_main_container_main.querySelectorAll('.sample-dot').forEach((dot, index) => {
          dot.addEventListener('click', () => {
            const products = sample_main_container_main.querySelectorAll('.sample-product');
            const productWidth = products[0].offsetWidth;
            let productsLength = products.length;
            const itemsPerSlide = (window.innerWidth >= 1024 && _GiftData?.template == "cart" && productsLength % 2 !== 0) ? 1.5 : (window.innerWidth >= 1024 && _GiftData?.template != "cart") ? 1 : (window.innerWidth >= 1024 && _GiftData?.template == "cart" && productsLength % 2 === 0) ? 2 : 1; // 2 cards per dot on desktop, 1 card per dot on mobile
            sample_main_container_main.querySelector('.sample-slider__container').scrollTo({
              left: index * productWidth * itemsPerSlide,
              behavior: 'smooth'
            });
          });
        });

        //add resize event listeners on dots updation
        window.addEventListener('resize', () => {
          this.updateDots(sample_main_container_main);
        });
        ///////// ends click and scroll event listeners for slider dots

        // Add event listener for checkbox changes (adding and removing products from the cart)
        this.handleSampleCheckboxChange('.sample-checkbox', "free sample", this.rerendaerSections.bind(this));
      })
      .catch(error => {
        console.error('Error fetching cart or parsing triggering products:', error);
      });
  }

  addSampleProductToCart(samples, cart) {
    if (samples.length >= 1) {
      samples.forEach((sample, idx) => {
        let sampleProductPresent = cart.items.find(item => item.properties && item.properties._sample === "free sample");
        if (idx === 0) {
          if (!sampleProductPresent) {
            fetch(`${this.locale}cart/add.js`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  quantity: 1,
                  id: sample.variants[0].id,
                  properties: {
                    _sample: "free sample"
                  }
                })
              })
              .then(response => response.json())
              .then(data => {
                if (_GiftData?.template == "cart") {
                  window.location.reload();
                } else {
                  this.rerendaerSections();
                } // Call rerender function
              })
              .catch(error => {});
          }
        }
      });
    }
  }

  remove_sample_product(cart) {
    let sampleLine = 1;
    //finding the line value of the sample product
    for (let i = 0; i < cart.items.length; i++) {
      if (cart.items[i].properties && cart.items[i].properties._sample === "free sample") {
        sampleLine = i + 1;

      }
    }
    const payload = {
      line: sampleLine,
      quantity: 0
    };

    fetch(`${this.locale}cart/change.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(payload),
      })
      .then(data => {
        this.rerendaerSections();
      })
      .catch(error => {
        console.error('There was a problem with the fetch operation:', error);
      });
  }

  // Update the createDots function
  createDots(container) {
    const products = container.querySelectorAll('.sample-product');
    const dotsContainer = container.querySelector('.sample-slider__dots');
    let productsLength = products.length;
    if (dotsContainer) {
      dotsContainer.innerHTML = '';
    }

    // Check if no dots should be shown for desktop with window.innerWidth >= 1024 when products count is <= 2
    if (window.innerWidth >= 1024 && productsLength <= 2) {
      return;
    }

    const itemsPerSlide = (window.innerWidth >= 1024 && _GiftData?.template == "cart" && productsLength % 2 !== 0) ? 1.5 : (window.innerWidth >= 1024 && _GiftData?.template != "cart") ? 1 : (window.innerWidth >= 1024 && _GiftData?.template == "cart" && productsLength % 2 === 0) ? 2 : 1; // 2 cards per dot on desktop, 1 card per dot on mobile
    let numberOfDots = Math.ceil(productsLength / itemsPerSlide);

    // Adjust for the specific case where productsLength is 5 and window width is >= 1024
    // if (window.innerWidth >= 1024 && productsLength === 5 && _GiftData?.template == "cart") {
    //   numberOfDots = 3;
    // }

    for (let i = 0; i < numberOfDots; i++) {
      let dot = document.createElement("div");
      dot.classList.add("sample-dot");
      dot.innerHTML = " ";
      if (dotsContainer) {
        dotsContainer.appendChild(dot);
      }
    }

    if (dotsContainer.firstChild) {
      dotsContainer.firstChild.classList.add('active');
    }
  }

  // Update the updateDots function
  updateDots(container) {
    const products = container.querySelectorAll('.sample-product');
    const dotsContainer = container.querySelector('.sample-slider__dots');
    const dots = dotsContainer.querySelectorAll('.sample-dot');
    const scrollLeft = container.querySelector('.sample-slider__container').scrollLeft;
    const productWidth = products[0].offsetWidth;
    let productsLength = products.length;
    const itemsPerSlide = (window.innerWidth >= 1024 && _GiftData?.template == "cart" && productsLength % 2 !== 0) ? 1.5 : (window.innerWidth >= 1024 && _GiftData?.template != "cart") ? 1 : (window.innerWidth >= 1024 && _GiftData?.template == "cart" && productsLength % 2 === 0) ? 2 : 1;
    const activeIndex = Math.round(scrollLeft / (productWidth * itemsPerSlide));

    dots.forEach(dot => dot.classList.remove('active'));
    if (dots[activeIndex]) {
      dots[activeIndex].classList.add('active');

      // Center the active dot
      const dotWidth = dots[0].offsetWidth + 4; // dot width + gap
      const containerWidth = dotsContainer.offsetWidth;
      const scrollPosition = (dotWidth * activeIndex) - (containerWidth / 2) + (dotWidth / 2);

      dotsContainer.scrollTo({
        left: scrollPosition,
        behavior: 'smooth'
      });
    }
  }

  async rerendaerSections() {
    await fetch(`${this.locale}cart`, {
        method: "GET",
        headers: {
          "Content-Type": "text/html",
          Accept: "text/html",
        },
      })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Error fetching cart");
        }
        return response.text();
      })
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const selectors = [
          ".drawer__inner",
          "#cart-icon-bubble",
          "#desktop-cart-icon-bubble",
          ".cart-item-wrapper",
          ".free-samples",
        ];
        selectors.forEach((selector) => {
          const currentElement = document.querySelector(selector);
          const newElement = doc.querySelector(selector);

          if (currentElement && newElement) {
            currentElement.innerHTML = newElement.innerHTML;
          }
        });
        document.dispatchEvent(new Event("freegift:updated"));
      })
      .catch((error) => {
        console.error("Error updating cart sections:", error);
      });
  }

  handleSampleProductToCart(checkbox, sample_criteria, rerenderCallback) {
    let productId = checkbox.getAttribute('data-product-id');
    let isProcessing = false; // Flag to prevent multiple calls
    if (checkbox.checked) {
      if (isProcessing) return; // Prevent multiple calls
      isProcessing = true;
      this.querySelectorAll(".sample-checkbox").forEach(c => {
        if (c !== checkbox) {
          c.disabled = true
        } else if (c === checkbox) {
          c.disabled = true
        } else {
          c.disabled = false
        }
      })
      // Uncheck all other checkboxes and remove their products from the cart
      let removalPromises = [];
      if (_sampleData?.sampleCount === 1) {
        this.querySelectorAll(".sample-checkbox").forEach((otherCheckbox) => {
          if (otherCheckbox !== checkbox && otherCheckbox.checked) {
            otherCheckbox.checked = false;
            let otherProductId = otherCheckbox.getAttribute("data-product-id");
            let removalPromise = fetch(`${this.locale}cart/change.js`, {
                method: "POST",
                headers: {
                  "Content-Type": "application/json"
                },
                body: JSON.stringify({
                  quantity: 0,
                  id: otherProductId
                }),
              })
              .then((response) => response.json())
              .then((data) => {
                // No need to call rerenderCallback here
              })
              .catch((error) => {
                console.error("Error removing previous product from cart");
              });
            removalPromises.push(removalPromise);
          }
        });
      }
      // Wait for all removal requests to complete before adding the new product
      Promise.all(removalPromises).then(() => {
        fetch(`${this.locale}cart/add.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              quantity: 1,
              id: productId,
              properties: {
                _sample: `${sample_criteria}`
              }
            })
          })
          .then(response => response.json())
          .then(data => {
            rerenderCallback(); // Call rerender function
            if (_GiftData?.template === "cart") {
              document.dispatchEvent(new Event("cart:sample_updated"));
            }
            // Ensure the free-sample section is visible
            const sample_main_container = this.querySelector('.free-samples');
            isProcessing = false;
            setTimeout(() => {
              this.querySelectorAll(".sample-checkbox").forEach(c => {
                if (c !== checkbox) {
                  c.disabled = false
                } else {
                  c.disabled = false
                }
              })
            }, 2000);
          })
          .catch(error => {
            isProcessing = false; // Reset the flag
            this.querySelectorAll(".sample-checkbox").forEach(c => {
              if (c !== checkbox) {
                c.disabled = false
              } else if (c === checkbox) {
                c.disabled = true
              } else {
                c.disabled = false
              }
            })
          });
      });
    } else {
      // Remove the product from the cart
      fetch(`${this.locale}cart/change.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            quantity: 0,
            id: productId
          })
        })
        .then(response => response.json())
        .then(data => {
          rerenderCallback(); // Call rerender function
          if (_GiftData?.template === "cart") {
            document.dispatchEvent(new Event("cart:sample_updated"));
          }
          // Ensure the free-sample section is visible
          const sample_main_container = this.querySelector('.free-samples');
          if (sample_main_container) {
            sample_main_container.classList.add("active");
            this.querySelector(".free-samples__header").classList.add("active");
          }
        })
        .catch(error => {});
    }
  }

  handleSampleCheckboxChange(checkboxSelector, sample_criteria, rerenderCallback) {
    this.querySelectorAll(checkboxSelector).forEach(checkbox => {
      checkbox.addEventListener('change', () => {
        this.handleSampleProductToCart(checkbox, sample_criteria, rerenderCallback);
      });
    });
  }
}

customElements.define('free-samples', FreeSamples);

async function fetchCartData() {
  try {
    const response = await fetch(`${routes.cart_url}.js`);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching cart data:', error);
    return null;
  }
}

/**
 *  Clear cart if only gift wrapper or sample product or gift product is present in cart
 */
(async function clearCart() {
  document.addEventListener('DOMContentLoaded', () => {
    document.addEventListener('cart:updated', async () => {
      const cartData = await fetchCartData();
      if (cartData) {
        const {
          items
        } = cartData;


        // console.log('hehehaha: ', cartData);

        let hasSpecialProduct = false;
        const otherProductsId = [];
        const bundleParentItems = [];
        const freeItems = [];

        // check if gift wrapper is already in cart
        items?.forEach((item) => {
          hasSpecialProduct = item.properties._gift_wrapper === 'Gift Wrapper' || item.properties._gift === `${_GiftData?.giftTriggeringCriteria}` || item.properties._sample === "free sample";
          if (!hasSpecialProduct) {
            otherProductsId.push(item.id);
          }

          if (item.has_components) {
            bundleParentItems.push(item.id)
          }

          if (item.final_price == 0) {
            freeItems.push(item.id)
          }
        });

        // remove free items if only they and a bundle remain
        if (bundleParentItems.length == 1 && cartData?.item_count == freeItems.length + bundleParentItems.length) {

          const updates = {};
          freeItems.forEach(id => updates[id] = 0);

          // await fetch('/cart/update.js', {
          //   ...fetchConfig(),
          //   body: JSON.stringify({ updates })
          // });

          await fetch('/cart/clear.js', {
            ...fetchConfig(),
          });

          setTimeout(async () => {
            await rerenderCartPageAndCartDrawer([
              'cart-drawer',
              'cart-drawer-items',
              '#main-cart-footer',
              'cart-items',
              '#drawer__footer',
              '#cart-icon-bubble',
              '#desktop-cart-icon-bubble',
            ]);
          }, 500);

        }


        if (hasSpecialProduct && otherProductsId.length === 0) {
          await fetch('/cart/clear.js', {
            ...fetchConfig(),
          });
          if (_GiftData?.template === "cart") {
            window.location.reload();

          } else {
            setTimeout(async () => {
              await rerenderCartPageAndCartDrawer([
                'cart-drawer',
                'cart-drawer-items',
                '#main-cart-footer',
                'cart-items',
                '#cart-icon-bubble',
                '#desktop-cart-icon-bubble',
              ]);
            }, 500);
          }
        }
      }
    });
  });
})();

/**
 *  Checking any samples are present in the cart or not
 */
async function checkSampleProductPresent() {
  const cartData = await fetchCartData()
  let sampleProductPresentCount = (cartData?.items?.filter(
    (item) =>
    item.properties && item.properties._sample === "free sample"
  )).length

  if (sampleProductPresentCount >= _sampleData?.sampleCount && _sampleData?.sampleCount > 1) {
    document.querySelectorAll(".sample-product .sample-checkbox").forEach(c => {
      let isProductInCart = false;
      cartData?.items?.forEach(item => {
        if (item?.id === Number(c.getAttribute("data-product-id"))) {
          isProductInCart = true;
        }
      });
      if (isProductInCart) {
        c.disabled = false;
        c.closest('label').style.opacity = 1; // Add opacity to the outer label
      } else {
        c.disabled = true;
        c.closest('label').style.opacity = 0.5; // Add opacity to the outer label
      }
    });
  } else {
    document.querySelectorAll(".sample-product .sample-checkbox").forEach(c => {
      c.disabled = false;
      c.closest('label').style.opacity = 1;
    })
  }
}

/**
 *  Re-render free sample section for cart page only
 */
(async function rerenderSamplesSection() {
  document.addEventListener("DOMContentLoaded", () => {
    document.addEventListener("cart:updated", async () => {
      const cartResponse = await fetch("/cart", {
        method: "GET",
        headers: {
          "Content-Type": "text/html",
          Accept: "text/html",
        },
      });

      if (!cartResponse.ok) {
        throw new Error("Error fetching cart");
      }

      const html = await cartResponse.text();

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");

      // just update entire cart page and cart drawer
      const currentElement = document.querySelector(".cart-page__free_samples");
      const newElement = doc.querySelector(".cart-page__free_samples");
      if (currentElement && newElement) {
        currentElement.innerHTML = newElement.innerHTML;
      }
      // hiding the free samples section if there are no free samples in cart page
      const cartData = await fetchCartData();
      if (cartData?.item_count === 0) {
        _GiftData?.template === "cart" && document.querySelector(".cart-page__free_samples")?.classList?.add("hidden");
      }
    });
  });
})();

/**
 *  Re-render the free gift section and underline for cart drawer only
 */
(async function getUnderLineToFreeGifts() {
  document.addEventListener("DOMContentLoaded", () => {
    document.addEventListener("freegift:updated", async () => {
      const headerContainer = document.querySelector(".free-gifts__header");

      console.log(headerContainer)

      if (!headerContainer) return; // prevent error if element not found

      if (_GiftData?.template !== "cart") {
        headerContainer.classList.remove("free-gifts__header-underline_cart");
        headerContainer.classList.add("free-gifts__header-underline_nocart");
      } else {
        headerContainer.classList.remove("free-gifts__header-underline_nocart");
        headerContainer.classList.add("free-gifts__header-underline_cart");
      }
    });
  });
})();

/**
 *  Re-render cart page and cart drawer
 *
 * @param {[]} selectors - List of selectors to re-render
 */
async function rerenderCartPageAndCartDrawer(selectors) {
  const cartResponse = await fetch('/cart', {
    method: 'GET',
    headers: {
      'Content-Type': 'text/html',
      Accept: 'text/html',
    },
  });

  if (!cartResponse.ok) {
    throw new Error('Error fetching cart');
  }

  const html = await cartResponse.text();

  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');

  // just update entire cart page and cart drawer
  setTimeout(() => {
    selectors.forEach((selector) => {
      const currentElement = document.querySelector(selector);
      const newElement = doc.querySelector(selector);

      if (currentElement && newElement) {
        currentElement.innerHTML = newElement.innerHTML;
      }
    });
  }, 500);
  setTimeout(() => {
    [
      "cart-drawer",
      "cart-drawer-items",
      "#main-cart-footer",
      "cart-items",
    ].forEach((selector) => {
      const currentElement = document.querySelector(selector);
      currentElement.classList.add("is-empty");
    });
    document
      .querySelector(".drawer__inner")
      .classList.replace(".drawer__inner-empty");
    document.querySelector(".drawer__inner").classList.remove("is-empty");
    document.querySelector(".drawer__inner-empty").classList.remove("is-empty");
  }, 1000);
}

customElements.define(
  'cart-discount-coupon',
  class extends HTMLElement {
    constructor() {
      super();
      this.discountForm = this.querySelector('#discount-form');
      this.clearDiscountButton = this.querySelector('.clear-discount-button');
    }

    connectedCallback() {
      this.addEventListeners();
    }

    addEventListeners() {
      this.discountForm?.addEventListener(
        'submit',
        this.handleDiscountSubmit.bind(this)
      );
      this.clearDiscountButton?.addEventListener(
        'click',
        this.handleClearDiscount.bind(this)
      );
    }

    async handleDiscountSubmit(event) {
      event.preventDefault();
      this.toggleLoading(true, this.discountForm);
      const discountCode = this.discountForm.querySelector('input').value;
      await this.applyCartDiscount(discountCode);
      this.toggleLoading(false, this.discountForm);
    }

    async handleClearDiscount() {
      this.toggleLoading(true, this.clearDiscountButton);
      await this.clearDiscount();
      this.toggleLoading(false, this.clearDiscountButton);
    }

    async applyCartDiscount(discountCode) {
      try {
        const [configData, cartData] = await Promise.all([
          this.fetchConfig(),
          this.fetchCart(),
        ]);

        const checkoutJsonUrl = '/wallets/checkouts/';
        const authorizationToken = btoa(
          configData?.paymentInstruments?.accessToken
        );

        const body = JSON.stringify({
          checkout: {
            country: Shopify.country,
            discount_code: discountCode,
            line_items: cartData.items,
            presentment_currency: Shopify.currency.active,
          },
        });

        const checkoutData = await this.fetchData(checkoutJsonUrl, {
          method: 'POST',
          headers: this.getHeaders(authorizationToken),
          body,
        });

        if (
          checkoutData.checkout &&
          checkoutData.checkout.applied_discounts.length > 0
        ) {
          await this.applyDiscountUrl(discountCode);
          this.render();
        } else {
          this.updateUIOnFailure();
        }
      } catch (error) {
        console.error('Error applying discount:', error);
        this.updateUIOnFailure();
      }
    }

    async clearDiscount() {
      await this.fetchData('/discount/__CLEAR__DISCOUNT__');
      this.render();
    }

    async fetchConfig() {
      const response = await fetch('/payments/config', {
        method: 'GET'
      });
      return response.json();
    }

    async fetchCart() {
      const response = await fetch('/cart.js');
      return response.json();
    }

    async applyDiscountUrl(code) {
      const discountApplyUrl = `/discount/${code}?v=${Date.now()}`;
      await this.fetchData(discountApplyUrl);
    }

    async fetchData(url, options = {}) {
      const response = await fetch(url, options);

      const contentType = response.headers.get('content-type');
      if (contentType && contentType.includes('application/json')) {
        return response.json();
      } else {
        return response.text();
      }
    }

    getHeaders(authorizationToken) {
      return {
        accept: '*/*',
        'cache-control': 'no-cache',
        authorization: 'Basic ' + authorizationToken,
        'content-type': 'application/json, text/javascript',
        pragma: 'no-cache',
        'sec-fetch-dest': 'empty',
        'sec-fetch-mode': 'cors',
        'sec-fetch-site': 'same-origin',
      };
    }

    toggleLoading(isLoading, element) {
      const applyButton =
        element.querySelector('.apply-discount-button') || element;
      const inputField = element.querySelector('input');
      const applyIcon =
        element.querySelector('.apply-discount') ||
        element.querySelector('.clear-discount');
      const loadingIcon = element.querySelector('.loading');

      applyButton.disabled = isLoading;
      if (inputField) inputField.disabled = isLoading;
      applyIcon.classList.toggle('display-none', isLoading);
      loadingIcon.classList.toggle('display-none', !isLoading);
    }

    updateUIOnFailure() {
      this.discountForm.classList.add('error');
      this.querySelector(
        '.discount-status-message .error-message'
      ).classList.remove('display-none');
    }

    async render() {
      const html = await this.fetchData('/cart', {
        method: 'GET',
        headers: {
          'Content-Type': 'text/html',
          Accept: 'text/html',
        },
      });

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const selectors = [
        '.drawer__inner',
        'cart-drawer-items',
        '#main-cart-footer',
        'cart-items',
      ];

      selectors.forEach((selector) => {
        const currentElement = document.querySelector(selector);
        const newElement = doc.querySelector(selector);

        if (currentElement && newElement) {
          currentElement.innerHTML = newElement.innerHTML;
        }
      });
    }
  }
);

// product variant dropdown webcomponent
class ProductVariantPicker extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.initializeVariantSelectors();
    this.initializeOptionNameClick();
    this.initializeAccordianScript();
  }
  initializeVariantSelectors() {
    this.querySelectorAll('.product-option input[type="radio"]').forEach(
      (radio) => {
        radio.addEventListener("change", async () => {
          const selectedOptions = [];
          this.querySelectorAll(
            '.product-option input[type="radio"]:checked'
          ).forEach((radio) => {
            selectedOptions.push(radio.value);
          });

          const matchedVariant = _ProductVariants.find((variant) => {
            return selectedOptions.every(
              (option, index) => option === variant.options[index]
            );
          });

          // Update the URL with the selected variant ID
          const newUrl = `${window.location.pathname}?variant=${matchedVariant.id}`;
          history.replaceState({
            path: newUrl
          }, "", newUrl);

          // Fetch the updated product content
          await this.fetchAndRenderProductContent(newUrl);
        });
      }
    );
  }

  initializeAccordianScript() {
    const accordions = document.querySelectorAll(
      ".product__info-container__accordion details"
    );

    accordions.forEach((accordion) => {
      accordion.addEventListener("click", () => {
        accordions.forEach((item) => {
          if (item !== accordion) {
            item.removeAttribute("open");
          }
        });
      });
    });
  }

  initializeOptionNameClick() {
    const optionNames = this.querySelectorAll(".option-name");
    const dropdowns = this.querySelectorAll(".swatch__input__pills_dropdown");

    optionNames.forEach((optionName, index) => {
      optionName.addEventListener("click", (event) => {
        event.stopPropagation();
        // Show or hide the corresponding dropdown
        const dropdown = this.querySelector(`#dropdown-${index}`);
        const accordionIcon = optionName.querySelector(".variant__accordian");
        if (accordionIcon) {
          if (dropdown) {
            if (dropdown.classList.contains("active")) {
              dropdown.classList.remove("active");
              accordionIcon.style.transform = "rotate(0deg) scale(1.5)";
            } else {
              dropdown.classList.add("active");
              accordionIcon.style.transform = "rotate(180deg) scale(1.5)";
            }
          }
        }
      });

      // hiding other dropdowns
      if (optionName.querySelector(".variant__accordian")) {
        optionName.addEventListener("click", () => {
          dropdowns.forEach((dropdown, dropdownIndex) => {
            if (dropdownIndex !== index) {
              dropdown.classList.remove("active");
              const accordionIcon = optionNames[dropdownIndex].querySelector(
                ".variant__accordian"
              );
              if (accordionIcon) {
                accordionIcon.style.transform = "rotate(0deg) scale(1.5)";
              }
            }
          });
        });
      }
    });

    document.addEventListener("click", (event) => {
      dropdowns.forEach((dropdown) => {
        if (!dropdown.contains(event.target)) {
          dropdown.classList.remove("active");
          const accordionIcon = dropdown.previousElementSibling.querySelector(
            ".variant__accordian"
          );
          if (accordionIcon) {
            accordionIcon.style.transform = "rotate(0deg) scale(1.5)";
          }
        }
      });
    });
  }

  async fetchAndRenderProductContent(newUrl) {
    try {
      const response = await fetch(newUrl);
      const html = await response.text();

      // Parse the HTML response
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");

      // Find the new product content
      const newProductContent = doc.querySelector(".product__info-wrapper");

      // Replace the existing product content with the new content
      const productContainer = document.querySelector(".product__info-wrapper");
      if (productContainer && newProductContent) {
        productContainer.innerHTML = newProductContent.innerHTML;

        // Reinitialize any necessary JavaScript for the new content
        this.reinitializeProductScripts();
      } else {
        console.error("Error: Product content not found.");
      }
    } catch (error) {
      console.error("Error fetching updated product content:", error);
    }
  }

  reinitializeProductScripts() {
    this.initializeVariantSelectors();
    this.initializeOptionNameClick();
    this.initializeAccordianScript();
  }
}

customElements.define("product-variant-picker", ProductVariantPicker);

class SvgLogo extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({
      mode: 'open'
    });
  }

  static get observedAttributes() {
    return ['src', 'alt', 'height', 'width', 'class'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'src') {
      this.loadSvg(newValue);
    } else {
      this.updateAttributes(name, newValue);
    }
  }

  connectedCallback() {
    const src = this.getAttribute('src');
    if (src) {
      this.loadSvg(src);
    }
    this.updateAttributes();
  }

  async loadSvg(src) {
    try {
      const response = await fetch(src);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const svgText = await response.text();
      this.shadowRoot.innerHTML = `
        <style>
          :host {
            display: inline-block;
            --svg-width: ${this.getAttribute('width') || 'auto'};
            --svg-height: ${this.getAttribute('height') || 'auto'};
          }
          svg {
            display: block;
            width: var(--svg-width);
            height: var(--svg-height);
            overflow: unset;
          }
        </style>
        ${svgText}
      `;
      this.updateAttributes();
    } catch (error) {
      console.error('Error loading SVG:', error);
    }
  }

  updateAttributes(name, value) {
    const svgElement = this.shadowRoot.querySelector('svg');
    if (!svgElement) return;

    if (name) {
      if (name === 'class') {
        svgElement.setAttribute('class', value);
      } else if (name === 'alt') {
        let title = svgElement.querySelector('title');
        if (!title) {
          title = document.createElement('title');
          svgElement.prepend(title);
        }
        title.textContent = value;
      } else {
        svgElement.setAttribute(name, value);
      }
    } else {
      ['alt', 'height', 'width', 'class'].forEach(attr => {
        const attrValue = this.getAttribute(attr);
        if (attrValue) {
          if (attr === 'class') {
            svgElement.setAttribute('class', attrValue);
          } else if (attr === 'alt') {
            let title = svgElement.querySelector('title');
            if (!title) {
              title = document.createElement('title');
              svgElement.prepend(title);
            }
            title.textContent = attrValue;
          } else {
            svgElement.setAttribute(attr, attrValue);
          }
        }
      });
    }
  }
}

customElements.define('svg-logo', SvgLogo);

//cart drawer to cart page redirection button
class CTARedirectionButton extends HTMLElement {
  constructor() {
    super();
    this.checkoutBtn = this.querySelector(".cart__checkout-button");
  }

  connectedCallback() {
    this.checkoutBtn.addEventListener("click", this.redirectToCart);
  }

  disconnectedCallback() {
    this.checkoutBtn.removeEventListener("click", this.redirectToCart);
  }

  redirectToCart() {
    const queryParams = window.location.search;
    if (queryParams) {
      window.location.href = `${window.Shopify.routes.root}cart${queryParams}`;
    } else {
      window.location.href = `${window.Shopify.routes.root}cart`;
    }
  }
}

customElements.define("cta-redirection-button", CTARedirectionButton);

//for video play-pause as in-grid-content banner
class VideoControl extends HTMLElement {
  constructor() {
    super();
    this.video = document.querySelector(".image-or-video-banner video");
    this.playPauseBtn = this.querySelector(".video-play-pause-btn");
    this.playIcon = this.querySelector(".play-icon");
    this.pauseIcon = this.querySelector(".pause-icon");
    this.muteUnmuteBtn = this.querySelector(".video-mute-unmute-btn");
    this.muteIcon = this.querySelector(".mute-icon");
    this.soundIcon = this.querySelector(".sound-icon");
    this.initializeVideoState();
  }

  connectedCallback() {
    if (this.video) {
      this.playPauseBtn.addEventListener("click", () => {
        if (this.video.paused) {
          this.video.play();
          this.playIcon.classList.add("display-none");
          this.pauseIcon.classList.remove("display-none");
        } else {
          this.video.pause();
          this.playIcon.classList.remove("display-none");
          this.pauseIcon.classList.add("display-none");
        }
      });

      this.video.addEventListener("ended", () => {
        playIcon.classList.remove("display-none");
        pauseIcon.classList.add("display-none");
      });

      this.muteUnmuteBtn.addEventListener("click", () => {
        if (this.video.muted) {
          this.video.muted = false;
          this.muteIcon.classList.add("display-none");
          this.soundIcon.classList.remove("display-none");
        } else {
          this.video.muted = true;
          this.muteIcon.classList.remove("display-none");
          this.soundIcon.classList.add("display-none");
        }
      });
    }
  }

  initializeVideoState() {
    if (this.video) {
      this.video.play();
      this.playIcon.classList.add("display-none");
      this.pauseIcon.classList.remove("display-none");
    }
  }
}

customElements.define("video-control", VideoControl);

class ScrollToForm extends HTMLElement {
  connectedCallback() {
    this.scrollToForm();
  }

  scrollToForm() {
    setTimeout(() => {
      this.querySelector('.main-contact__container').scrollIntoView({
        behavior: 'smooth'
      });
    }, 100); // Adjust the delay as needed
  }
}
customElements.define('scroll-to-form', ScrollToForm);







class AutoAdder extends HTMLElement {
  constructor() {
    super();
    this.isProcessing = false; 
    this.isAddingGift = false;
  }

  connectedCallback() {
    document.addEventListener("DOMContentLoaded", () => {
      document.addEventListener("cart:updated", this.handleCartUpdate.bind(this));
      window.addEventListener("cart:updated", this.handleCartUpdate.bind(this));
    });
  }

  async handleCartUpdate() {
    if (this.isProcessing || this.isAddingGift) return;
    this.isProcessing = true;

    try {
      const cartResponse = await fetch("/cart.js");
      if (!cartResponse.ok) throw new Error("Error fetching cart");
      const cart = await cartResponse.json();

      const threshold = parseFloat(this.getAttribute("data-t")) * 100; // convert to cents
      const giftVariantId = Number(this.getAttribute("data-item").split("/").pop());

      const giftItems = cart.items.filter((item) => item.variant_id === giftVariantId);
      const hasGiftItem = giftItems.length > 0;
      const giftItem = giftItems[0];

      // total excluding the gift
      const adjustedTotal = cart.items
        .filter((item) => item.variant_id !== giftVariantId)
        .reduce((sum, item) => sum + item.final_line_price, 0);

      // ✅ Threshold met — ensure exactly ONE gift
      if (adjustedTotal >= threshold) {
        if (!hasGiftItem) {
          await this.addGiftItem(giftVariantId);
        } else if (giftItems.length > 1 || giftItem.quantity > 1) {
          // if customer somehow has multiple, fix it
          await this.fixGiftQuantity(giftItem.key);
        } else {
          console.log("Gift already in cart.");
        }
      } 
      // ❌ Threshold not met — remove gift
      else {
        if (hasGiftItem) {
          await this.removeGiftItem(giftItem);
        }
      }
      await new Promise((r) => setTimeout(r, 800));
      await this.rerenderSections();
    } catch (error) {
      console.error("Error handling cart update:", error);
    } finally {
      this.isProcessing = false;
    }
  }

  async addGiftItem(giftVariantId) {
    if (this.isAddingGift) return;
    this.isAddingGift = true;

    try {
      const formData = {
        items: [
          {
            id: giftVariantId,
            quantity: 1,
            properties: { _aa: true },
          },
        ],
      };

      const addResponse = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      if (!addResponse.ok) throw new Error("Failed to add item");

      // Re-fetch cart to confirm gift presence before re-render
      // await new Promise((r) => setTimeout(r, 800)); // small delay for Shopify sync
      // await this.rerenderSections();
    } catch (error) {
      console.error("Error auto-adding item:", error);
    } finally {
      this.isAddingGift = false;
    }
  }

  async fixGiftQuantity(giftKey) {
    try {
      await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: giftKey,
          quantity: 1,
        }),
      });
      // await this.rerenderSections();
    } catch (error) {
      console.error("Error fixing gift quantity:", error);
    }
  }

  async removeGiftItem(giftItem) {
    try {
      const removeResponse = await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: giftItem.key,
          quantity: 0,
        }),
      });

      if (!removeResponse.ok) throw new Error("Failed to remove item");
    } catch (error) {
      console.error("Error removing gift item:", error);
    }
  }

  async rerenderSections() {
    try {
      const response = await fetch(window.Shopify.routes.root + "cart", {
        method: "GET",
        headers: {
          "Content-Type": "text/html",
          Accept: "text/html",
        },
      });

      if (!response.ok) throw new Error("Error fetching cart");
      const html = await response.text();

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const newgiftsContainer = doc.querySelector(".free-gifts");
      const giftsContainer = document.querySelector(".free-gifts");
      const selectors = [
        ".drawer__inner",
        "#cart-icon-bubble",
        "#desktop-cart-icon-bubble",
        ".cart-item-wrapper",
        ".free-gifts",
      ];

      selectors.forEach((selector) => {
        const currentElement = document.querySelector(selector);
        const newElement = doc.querySelector(selector);
        if (currentElement && newElement) {
          currentElement.innerHTML = newElement.innerHTML;
        }
      });

      if (giftsContainer && newgiftsContainer) {
        giftsContainer.innerHTML = newgiftsContainer.innerHTML;
        giftsContainer.classList.add("active");
      }

      document.dispatchEvent(new Event("freegift:updated"));
    } catch (error) {
      console.error("Error updating cart sections:", error);
    }
  }
}

customElements.define("auto-adder", AutoAdder);
